import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import { reducer as formReducer } from 'redux-form'
import { adminReducer } from './adminReducer';
import { userReducer } from './userReducer';
import { dialogReducer } from './dialogReducer';

function rootReducer(history) {
    return (
        combineReducers({
            router: connectRouter(history),
            userReducer,
            adminReducer,
            dialogReducer,
            form: formReducer
        })
    );
}

export default rootReducer;